import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, select, put, takeEvery } from 'redux-saga/effects';
import { userAnnouncements } from 'redux/saga/entities/bound';
import { showModal, hideModal } from 'redux/modules/modals';
import { isLoggedIn, pathSelector } from 'redux/saga/selectors';
import { readSessionStorage, writeSessionStorage } from 'redux/saga/helpers/local-storage';
import { deepExtract } from 'helpers/deep';
import { error } from 'universal-logger';

const LOAD_TERMS_AND_CONDITIONS = 'LOAD_TERMS_AND_CONDITIONS';
const ACCEPT_TERMS_AND_CONDITIONS = 'ACCEPT_TERMS_AND_CONDITIONS';

export const loadAnnouncements = () => ({ type: LOAD_TERMS_AND_CONDITIONS });
export const acceptAnnouncement = referenceHash => ({ type: ACCEPT_TERMS_AND_CONDITIONS, referenceHash });

export function* doLoadAnnouncements(client) {
  try {
    const [path, isUserLoggedIn, unseenAnnouncementsCount] = yield all([
      select(pathSelector),
      select(isLoggedIn),
      call(readSessionStorage, 'unseenAnnouncements'),
    ]);
    // Announcements should not show up on any of the terms pages
    const isTermsPages = path.indexOf('/terms') !== -1;
    const hasSeenAllAnnouncements = unseenAnnouncementsCount === 0;
    if (!isTermsPages && isUserLoggedIn && !hasSeenAllAnnouncements) {
      const userAnnouncementsList = yield call(fetchEntityIfNeeded, userAnnouncements, [client]);
      const announcementCount = deepExtract('announcements.length', userAnnouncementsList, 0);
      // to avoid calling the the api multiple times we store the amount of unseen announcements so that we know if we should call the api the next time.
      yield call(writeSessionStorage, 'unseenAnnouncements', announcementCount);
      if (announcementCount > 0) {
        yield put(showModal('AnnouncementsModal'));
      }
    }
  } catch (err) {
    yield call(error, 'Error loading announcements', err.message);
  }
}

export function* doAcceptAnnouncement(client, { referenceHash }) {
  try {
    yield all([
      call(client.users.claimAnnouncements, [referenceHash], { status: 'consent' }),
      put(hideModal('AnnouncementsModal')),
    ]);
  } catch (err) {
    yield all([call(error, 'Error accepting announcement', err.message), put(hideModal('AnnouncementsModal'))]);
  }
}

export function* watchAnnouncements(client) {
  yield takeEvery(LOAD_TERMS_AND_CONDITIONS, doLoadAnnouncements, client);
  yield takeEvery(ACCEPT_TERMS_AND_CONDITIONS, doAcceptAnnouncement, client);
}
